import { apiSlice } from './apiSlice';

export const priceHistoryApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSundialPriceHistory: builder.query({
            query: ({ search, brandId, categoryName, page = 1, limit = 20, bulk } = {}) => ({
                url: 'admin/price-history/products',
                method: 'GET',
                params: {
                    search,
                    brandId,
                    categoryName,
                    page,
                    limit,
                    bulk
                },
            }),
            providesTags: ['PriceHistory'],
            keepUnusedDataFor: 120,
        }),
        getProductPriceHistory: builder.query({
            query: ({ productId, page = 1, limit = 50 } = {}) => ({
                url: `admin/price-history/product/${productId}`,
                method: 'GET',
                params: { page, limit },
            }),
            providesTags: (result, error, { productId }) => [{ type: 'PriceHistory', id: productId }],
            keepUnusedDataFor: 120,
        }),
        getPriceHistoryTrend: builder.query({
            query: ({ productId, days = 30, seller } = {}) => ({
                url: `admin/price-history/product/${productId}/trend`,
                method: 'GET',
                params: { days, seller },
            }),
            providesTags: (result, error, { productId }) => [{ type: 'PriceHistory', id: productId }],
            keepUnusedDataFor: 120,
        }),
        bulkImportPriceHistory: builder.mutation({
            query: (data) => ({
                url: 'admin/price-history/bulk-import',
                method: 'POST',
                data: data,
            }),
            invalidatesTags: ['PriceHistory'],
        }),
        importFromFile: builder.mutation({
            query: (data) => ({
                url: 'admin/price-history/import-file',
                method: 'POST',
                data: data,
            }),
            invalidatesTags: ['PriceHistory'],
        }),
        getPriceHistoryStats: builder.query({
            query: ({ productId, seller } = {}) => ({
                url: 'admin/price-history/stats',
                method: 'GET',
                params: { productId, seller },
            }),
            providesTags: ['PriceHistory'],
        }),
        getPriceHistoryCategories: builder.query({
            query: () => ({
                url: 'admin/price-history/categories',
                method: 'GET',
            }),
            providesTags: ['PriceHistory'],
        }),
        updateCategoryPriorityPrice: builder.mutation({
            query: (data) => ({
                url: 'admin/price-history/categories/priority-price',
                method: 'POST',
                data: data,
            }),
            invalidatesTags: ['PriceHistory'],
        }),
        getPriceHistoryVendors: builder.query({
            query: () => ({
                url: 'admin/price-history/vendors',
                method: 'GET',
            }),
            providesTags: ['PriceHistory'],
        }),
        getPriceHistoryBrands: builder.query({
            query: () => ({
                url: 'admin/price-history/brands',
                method: 'GET',
            }),
            providesTags: ['PriceHistory'],
        }),
        updateVendorPriorityPrice: builder.mutation({
            query: (data) => ({
                url: 'admin/price-history/vendors/priority-price',
                method: 'POST',
                data: data,
            }),
            invalidatesTags: ['PriceHistory'],
        }),
        recalculateProductPriorityPoints: builder.mutation({
            query: (data = {}) => ({
                url: 'admin/price-history/priority-point/recalculate',
                method: 'POST',
                data: data,
            }),
            invalidatesTags: ['PriceHistory'],
        }),
        updateLatestFlags: builder.mutation({
            query: (data) => ({
                url: 'admin/price-history/update-latest',
                method: 'POST',
                data: data,
            }),
            invalidatesTags: ['PriceHistory'],
        }),
        deletePriceHistoryRecords: builder.mutation({
            query: (params) => ({
                url: 'admin/price-history',
                method: 'DELETE',
                data: params,
            }),
            invalidatesTags: ['PriceHistory'],
        }),
        updateVendorCrawlFrequency: builder.mutation({
            query: (data) => ({
                url: 'admin/price-history/vendors/crawl-frequency',
                method: 'POST',
                data: data,
            }),
            invalidatesTags: ['PriceHistory'],
        }),
        getPriceHistoryBatchIds: builder.query({
            query: () => ({
                url: 'admin/price-history/batch-ids',
                method: 'GET',
            }),
            providesTags: ['PriceHistory'],
        }),
    }),
});

export const {
    useGetSundialPriceHistoryQuery,
    useLazyGetSundialPriceHistoryQuery,
    useGetProductPriceHistoryQuery,
    useGetPriceHistoryTrendQuery,
    useBulkImportPriceHistoryMutation,
    useImportFromFileMutation,
    useGetPriceHistoryStatsQuery,
    useGetPriceHistoryCategoriesQuery,
    useUpdateCategoryPriorityPriceMutation,
    useGetPriceHistoryVendorsQuery,
    useUpdateVendorPriorityPriceMutation,
    useRecalculateProductPriorityPointsMutation,
    useUpdateLatestFlagsMutation,
    useDeletePriceHistoryRecordsMutation,
    useUpdateVendorCrawlFrequencyMutation,
    useGetPriceHistoryBatchIdsQuery,
    useGetPriceHistoryBrandsQuery,
} = priceHistoryApi;